import React from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import navigationActions from "../../../common/components/navigation/action";
import { DataForm, LiteDataForm } from "../form";
import actions from "../actions";
import { IsLiteVersion, IsFullVersion } from "../../../common/utils/system-version-helper";
import "./DataPage.scss";

class DataEditPage extends React.Component {
  componentDidMount() {
    this.props.dispatch(navigationActions.changePage("register"));
    this.props.dispatch(actions.GetVictimDataById(this.props.match.params.regid));
  }

  UpdateData = (val) => {
    this.props.dispatch(actions.UpdateVictimData(val));
  };

  handleCancel = () => {
    this.props.dispatch(push(`/register`));
  };

  render() {
    return (
      <div className="p5-page-container">
        <Row justify="center">
          <Col xs={20} md={20} lg={18}>
            {IsFullVersion() === true && (
              <DataForm
                loading={this.props.loading}
                onSubmit={this.UpdateData}
                onCancel={this.handleCancel}
                {...this.props.victimData}
              />
            )}
            {IsLiteVersion() === true && (
              <LiteDataForm
                loading={this.props.loading}
                onSubmit={this.UpdateData}
                onCancel={this.handleCancel}
                {...this.props.victimData}
              />
            )}            
          </Col>
        </Row>
      </div>
    );
  }
}

DataEditPage.propTypes = {
  dispatch: () => {},
  match: PropTypes.shape(),
  victimData: PropTypes.shape({}),
  loading: PropTypes.bool,
};

DataEditPage.defaultProps = {
  dispatch: () => {},
  match: {},
  victimData: {},
  loading: false,
};

function mapStateToProps(state) {
  const { victimData, loading } = state.RegisterUserFormState;
  return {
    victimData,
    loading
  };
}

const connectedDataEditPage = connect(mapStateToProps)(DataEditPage);

export default connectedDataEditPage;
